import React, { FC, useEffect, useState } from 'react'
import { StandingsInterface } from './Standings.interface'
import { StandingsTable } from './StandingsTable'
import styles from './Standings.module.scss'
import { Loader } from '../../Loader/Loader'
import {
  EventForStats,
  getAllChannelEventsForStats
} from 'api/multistageTournament/getChannelEvents'
import { getStandingsFromService } from 'api/standings/getStandingsFromService'
import ContentSlider from 'components/sliders/ContentSlider'

interface StandingsProps {
  channelSlug: string
  showExpandedToggle: boolean
  teamSlug?: string
}

export const Standings: FC<StandingsProps> = (props) => {
  const { channelSlug, showExpandedToggle, teamSlug } = props
  const slug = channelSlug
  const [events, setEvents] = useState<EventForStats[]>([])
  const [tablesData, setTablesData] = useState<StandingsInterface[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    if (slug) {
      getAllChannelEventsForStats(slug)
        .then((response: EventForStats[]) => {
          setEvents(response)
          if (response.length == 0) {
            setIsLoading(false)
          } else {
            setIsLoading(true)
          }
        })
        .catch((error) => {
          console.log(error)
          setIsLoading(false)
        })
    }
  }, [slug])

  useEffect(() => {
    const fetchTableData = async () => {
      setIsLoading(true)
      const promises = events.map((event: EventForStats) =>
        getStandingsFromService({
          externalSystemId: event.external_system,
          eventReference: event.external_reference,
          groupReferences: event.groups?.map(
            (group: any) => group.external_reference
          )
        }).then((response: StandingsInterface[]) => response)
      )
      try {
        const results = await Promise.all(promises)
        const combinedResults = results.flat()
        if(combinedResults.length > 0) {
          setTablesData(combinedResults)
        }
      } catch (error) {
        console.log(error)
      }
      setIsLoading(false)
    }
    if (events.length > 0) {
      fetchTableData()
    }
  }, [events])

  if (isLoading) {
    return <Loader />
  }

  if (tablesData.length > 0) {
    return (
      <div className={styles.StandingsContainer}>
        <ContentSlider leftPadding={true} showArrows useLightBackground={true}>
          {tablesData.map((standings: StandingsInterface, index: number) => (
            <div className={styles.TableWrapper} key={`Standings__${index}`}>
              <StandingsTable
                standings={standings}
                showExpandedToggle={showExpandedToggle}
                teamSlug={teamSlug}
              />
            </div>
          ))}
        </ContentSlider>
      </div>
    )
  } else {
    return null
  }
}
